export const getEffectiveDependents = responsible => {
  const dependents = responsible.dependents || [];
  const checkedDependents = dependents.filter(dependent => dependent.checked);

  if (checkedDependents.length > 0) {
    return checkedDependents;
  }

  return dependents;
};

export const buildResponsibleStudentLinks = subscribers => {
  return subscribers
    .filter(user => user.typeUser === "sponsor" && user.checked)
    .flatMap(responsible =>
      getEffectiveDependents(responsible).map(dependent => ({
        userId: responsible.id,
        studentId: dependent.id
      }))
    );
};

export const getDefaultDependentChecked = dependents => {
  return dependents.length === 1;
};

export const getRecipientsSummary = (users, isCpfRecipientList) => {
  const checkedUsers = users.filter(user => user.checked);

  if (!checkedUsers.length) {
    return "Nenhum destinatário selecionado";
  }

  if (!isCpfRecipientList) {
    const count = checkedUsers.length;
    return `${count} destinatário${count > 1 ? "s" : ""} selecionado${
      count > 1 ? "s" : ""
    }`;
  }

  const responsibles = checkedUsers.filter(user => user.typeUser === "sponsor");
  const directStudents = checkedUsers.filter(user => user.typeUser !== "sponsor");
  const linkedDependents = responsibles.reduce(
    (total, responsible) => total + getEffectiveDependents(responsible).length,
    0
  );

  const parts = [];

  if (responsibles.length) {
    parts.push(
      `${responsibles.length} ${
        responsibles.length > 1 ? "responsáveis" : "responsável"
      }`
    );
  }

  if (linkedDependents) {
    parts.push(
      `${linkedDependents} aluno${linkedDependents > 1 ? "s" : ""} vinculado${
        linkedDependents > 1 ? "s" : ""
      }`
    );
  }

  if (directStudents.length) {
    parts.push(
      `${directStudents.length} aluno${directStudents.length > 1 ? "s" : ""} na lista`
    );
  }

  return parts.join(" · ");
};

export const areAllDependentsMarked = users => {
  const checkedResponsibles = users.filter(
    user => user.typeUser === "sponsor" && user.checked && user.dependents?.length
  );

  if (!checkedResponsibles.length) {
    return false;
  }

  return checkedResponsibles.every(responsible =>
    responsible.dependents.every(dependent => dependent.checked)
  );
};
